//lrfci
import ConsultaRelatoriosLRFCI from '@/views/entregas/lrfci/ConsultaRelatoriosLRFCI.vue'
import CriarRelatorioLRFCI from '@/views/entregas/lrfci/CriarRelatorioLRFCI.vue'
import DetalhesRelatorioLRFCI from '@/views/entregas/lrfci/DetalhesRelatorioLRFCI.vue'
//legis
import ConsultaLegislacao from '@/views/entregas/legislacao/ConsultaLegislacao.vue'
import DetalhesLegislacao from '@/views/entregas/legislacao/DetalhesLegislacao.vue'
import EntregaLegislacao from '@/views/entregas/legislacao/EntregaLegislacao.vue'
//pcm
import ConsultaPrestacoesContaMensais from '@/views/entregas/pcm/ConsultaPrestacoesContaMensais.vue'
import ContasMensaisEntregaComponent from '@/views/entregas/pcm/EntregaPCM.vue'
import DetalhesEntregaPCM from '@/views/entregas/pcm/DetalhesPCM.vue'
import EntregaAssinaturaModalPCMComponent from '../views/entregas/pcm/AssinaturaModalPCM.vue'
import DeParaContasCaixa from '@/views/entregas/contas-caixa/DeParaContasCaixa.vue'
import ContasInativarView from '@/views/entregas/contas-inativar/ContasInativar.vue'
//pca
import ContasAnuaisConsultaComponent from '@/views/entregas/pca/ConsultaPCA.vue'
import ContasAnuaisEntregaComponent from '@/views/entregas/pca/EntregaPCA.vue'
import ContasAnuaisExportarComponent from '@/views/entregas/pca/ExportaPCA.vue'
import ContasAnuaisAssinaturaModalComponent from '@/views/entregas/pca/AssinaturaPCAModal.vue'
//Contato
import ContatosResponsaveis from '@/views/entregas/contato/ContatosResponsaveis.vue'
//Emendas
import ConsultarEmendas from '@/views/entregas/emendas/ConsultarEmenda.vue'
import EditarEmendas from '@/views/entregas/emendas/EditarEmendas.vue'

const entregasRotas = [
  {
    "path": "/entrega/relatorios-lrf-ci",
    "name": "entrega--relatorios-lrf-ci",
    "component": ConsultaRelatoriosLRFCI,
  },
  {
    "path": "/entrega/enviar-lrf-ci",
    "name": "entrega--enviar-lrf-ci",
    "component": CriarRelatorioLRFCI,
  },
  {
    "path": "/entrega/detalhes-lrf-ci/:relatorio",
    "name": "entrega--detalhes-lrf-ci",
    "component": DetalhesRelatorioLRFCI,
    props: true
  },
  {
    "path": "/entrega/legislacoes",
    "name": "entrega--legislacoes",
    "component": ConsultaLegislacao
  },
  {
    "path": "/entrega/detalhes-legislacao/:idEntrega",
    "name": "entrega--detalhes-legislacao",
    "component": DetalhesLegislacao,
    props: true
  },
  {
    "path": "/entrega/enviar-legislacao",
    "name": "entrega--enviar-legislacao",
    "component": EntregaLegislacao,
    props: true
  },
  {
    "path": "/entrega/prestacoes-contas-mensais",
    "name": "entrega--prestacoes-contas-mensais",
    "component": ConsultaPrestacoesContaMensais,
  },
  {
    "path": "/entrega/prestacoes-contas-mensais/:idpcm",
    "name": "entrega--detalhes-pcm",
    "component": DetalhesEntregaPCM,
    props: true,
    children: [
      {
        path: '/entrega/prestacoes-contas-mensais/assinatura/:idpcm/:codsignatario',
        name: 'assinatura-modal-pcm',
        component: EntregaAssinaturaModalPCMComponent,
        props: true
      },
    ]
  },
  {
    path: '/entrega/enviar-pcm',
    name: 'contas-mensais-entrega',
    component: ContasMensaisEntregaComponent,
    props: true
  },
  {
    path: '/contas-anuais/entrega/:IdPrestacaoConta?',
    name: 'entrega',
    component: ContasAnuaisEntregaComponent,
    props: true
  },
  {
    path: '/contas-anuais/consulta',
    name: 'consulta',
    component: ContasAnuaisConsultaComponent,
    children: [
      {
        path: '/contas-anuais/consulta/assinatura/:id_pca?',
        name: 'assinatura-modal',
        component: ContasAnuaisAssinaturaModalComponent,
        props: true
      },
    ]
  },
  {
    path: '/contas-anuais/exportar',
    name: 'exportar',
    component: ContasAnuaisExportarComponent,
    props: true
  },
  {
    path: '/entrega/contas-caixa',
    name: 'contas--caixa',
    component: DeParaContasCaixa,
  },
  {
    path: '/entrega/contatos-responsaveis',
    name: 'contatos-responsaveis',
    component: ContatosResponsaveis,
    props: true
  },
  {
    path: '/entrega/emendas',
    name: 'consultar-emendas',
    component: ConsultarEmendas,
  },
  {
    path: '/entrega/editar-emendas',
    name: 'editar--emendas',
    component: EditarEmendas,
    props: true
  },
  {
    path: '/entrega/contas-inativar',
    name: 'contas--inativar',
    component: ContasInativarView
  }
]

export { entregasRotas };